<template>
    <div class="container">

        <div class="innercontain">
            <div class="top">
                <div>
                    <img src="../../assets/images/aboutus/icon_connetUs.png" width="45" height="45" alt="">
                </div>
                <div class="second">
                    <p style="font-size: 16px">电话联系客服：400-100-2226</p>
                    <p style="font-size: 14px;color: #a5a5a5;margin-top: 5px">周一至周日&nbsp;&nbsp;07:00~21:00</p>
                </div>
            </div>
            <div style="margin-top: 10px" class="bottom">
                <van-collapse v-model="activeNames">
                    <van-collapse-item title="一、搭把手主要回收哪些可回收物" name="1">
                        <p>1.纸类回收常见种类：纸板、书本、报纸</p>
                        <p>2.织物回收常见种类：衣服、围巾、毛绒玩具</p>
                        <p>3.玻璃回收常见种类：玻璃瓶、玻璃杯、玻璃碎片</p>
                        <p>4.塑料回收常见种类：塑料玩具、塑料容器、塑料瓶</p>
                        <p>5.塑料瓶投递：矿泉水瓶、饮料瓶、易拉罐</p>
                        <p>
                            其余分类详情可参考公众号内“回收指南”的“分类查询”进行查看
                        </p>
                    </van-collapse-item>
                    <van-collapse-item title="二、搭把手不可回收物" name="2">
                        <p>常见不可回收物：</p>
                        <p class="secondStyle">厨余垃圾：菜叶、剩饭、零食袋、奶茶杯</p>
                        <p class="secondStyle">有害垃圾：废涂料溶剂、废灯管、废弃电池、电路板</p>
                        <p class="secondStyle">其他垃圾：卫生纸、牙刷、一次性餐具、保鲜膜</p>
                        <p>上述物品暂时不可回收，投递之前请对照查看。</p>
                        <p>温馨提示：投售物品请分类后进行投放，请勿混仓放置或恶意投售，违规现象一经核实，即采取相应措施或上报至有关部门，情节严重的将移交司法机关处理。诚信投售，文明你我。</p>
                    </van-collapse-item>
                    <van-collapse-item title="三、如何投递" name="3">
                        <p>1.微信搜索“搭把手回收”，关注公众号</p>
                        <p>2.公众号内选择“我要投售”，注册登录</p>
                        <p>3.箱体触屏选择投递物类型</p>
                        <p>4.选择投递方式：输入手机号或扫描二维码</p>
                        <p>5.二代机子点击“我的二维码”，将二维码对准扫码区，箱门打开</p>
                        <p>6.三代机子点击“扫一扫”，扫描屏幕二维码进行投售</p>
                        <p>7.完成投递，收到积分</p>
                        <p>8.塑料瓶或易拉罐瓶身条码朝上置入投瓶口完成投递</p>
                    </van-collapse-item>
                    <van-collapse-item title="四、如何查看收益和提现" name="4">
                        <p>1.下载并打开“搭把手回收”APP进入我的——我的资源币。</p>
                        <p>2.选择提现方式，微信提现或支付宝提现</p>
                        <p>3.绑定您的实名信息，确认实名与搭把手所绑定的相一致。</p>
                        <p>4.进行提现。</p>
                        <p>5.或直接进入小程序“搭把手回收”，点击“我的资源币”后进行提现。</p>
                        <p>6.提现会在3个工作日内到账，节假日会顺延。</p>
                        <p>有关提现问题也可以拨打客服小姐姐电话: 400-100-2226</p>
                    </van-collapse-item>
                    <van-collapse-item title="五、投递后遇到问题" name="5">
                        <p class="question">Q：投递后无资源币返还</p>
                        <p>您好，低于60克是无法称重并且返还资源币的哦</p>
                        <p>若屏幕显示重量后无及时收到返还，请您关闭微信端网页或App端软件，重新打开后查看资源币返还情况。若半小时后还未有返还记录麻烦您再次拨打我们的客服热线。</p>
                        <p class="question">Q：电子显示器黑屏</p>
                        <p>您好，我们的机器系统后台正在进行排查检修，待检修完毕后方可进行投递。</p>
                        <p>客服热线：400-100-2226</p>
                    </van-collapse-item>
                    <van-collapse-item title="六、可回收物回收单价查询" name="6">
                        <p>其余详情价格请登录“搭把手回收”APP，点击我要投售，选择废品价格进行查询</p>
                    </van-collapse-item>
                    <van-collapse-item title="七、如何关注搭把手公众号" name="7">
                        <p>扫描二维码进行关注，或进入微信搜索“搭把手回收”关注即可。</p>
                    </van-collapse-item>
                    <van-collapse-item title="八、如何下载搭把手APP" name="8">
                        <p>1.各大应用市场均有下载“搭把手回收”APP</p>
                        <p>2.登录“搭把手回收”公众微信号—回收指南—APP下载即可</p>
                    </van-collapse-item>
                    <van-collapse-item title="九、大件预约回收" name="9">
                        <p class="question">Q：如何预约服务</p>
                        <p>请您进入“搭把手APP”页面，点击“我要预约”按钮并且填写预约回收的相关信息后，确认即可，随后会有工作人员跟您确认订单后进行上门收取</p>
                        <p class="question">Q：大件预约需要收取费用吗</p>
                        <p>部分配套设施完善区域大件预约人工运费可全免，其余地区高价值物品满50公斤不收取费用，其余物品上门回收人工费用全免，但是会收取一定的运费</p>
                        <p class="question">Q：不管多少东西都能预约吗</p>
                        <p>重量在50公斤以上可大件预约，称重不符合50公斤是会收取一定上门服务费用</p>
                    </van-collapse-item>
                    <van-collapse-item title="十、关于资源币" name="10">
                      <ul>
                        <li>1.资源币是“搭把手回收”平台所设的虚拟货币，用户投放可回收物后按一定价格以资源币形式进行结算，1资源币=1元人民币。</li>
                        <li>2.账户累计10资源币（含）可通过小程序/APP发起现金提现。</li>
                        <li>3.单次提现金额上限为500资源币，如提现金额超过500资源币，请分多次进行操作。</li>
                      </ul>
                    </van-collapse-item>

                    <van-collapse-item title="十一、用户投递注意事项" name="11">
                        <p>
                            用户投递温馨提示：尊敬的用户您好，您在投递过程中请正确分类投递，请将分类好的回收物品投入对应仓内，切勿将垃圾等不可回收物投入智能柜内，对违规投售、刷单、违规拉新（无效身份证、无效电话号码、无效用户）等使用不正当手段进行的套现行为，将影响个人征信，涉嫌违法行为。平台有权对对应账号进行拉黑、资源币冻结等风控处理。
                        </p>
                    </van-collapse-item>


                </van-collapse>
            </div>

        </div>
    </div>
</template>

<script>
    import { Collapse, CollapseItem } from 'vant';
    export default {
        name: "helpCenter",
        components:{
            [Collapse.name] :Collapse,
            [CollapseItem.name] :CollapseItem
        },
        data(){
            return{
                activeNames: ['1'],

            }
        }
    }
</script>

<style scoped>
    .container{
        background-color: #F8F8F8;
        min-height: 100vh;
    }
    .nav_title{
        position: fixed;
        width: 100%;
        height: 60px;
        line-height: 60px;
        background-color: white;
        text-align: center;
        color: #030303;
        font-size: 16px;
        font-weight: 600;
    }
    .nav_title .imgBox{
        position: absolute;
        left: 15px;
        top: -2px;
    }
    .top{
        display: flex;
        align-items: center;
        padding: 20px 20px;
        background-color: white;
    }
    .second{
        margin-left: 20px;
    }
    .question{
        color:orange ;
        padding: 5px 0 ;
    }
    .secondStyle{
        text-indent:1em;
    }
    .bottom p{
        margin-top: 3px;
    }

</style>
